import isNil from 'lodash-es/isNil';
import { useMemo } from 'react';
import { queryClient, useClient, useMutation, useQuery } from '../..';
const useVirtualDevice = ({ orgId, plotId, onSuccess, getDeviceIds }) => {
    const client = useClient();
    const orgRequester = client.orgs.get(orgId);
    const orgRequest = useQuery(orgRequester, { enabled: !isNil(orgId) });
    const org = orgRequest.data;
    const plotRequester = client.plots.get(plotId);
    const plotRequest = useQuery(plotRequester, { enabled: !isNil(plotId) });
    const plot = plotRequest.data;
    const [updateDevices, updateDevicesRequest] = useMutation(client.plots.updateDevices(plot?.id));
    /**
     * Optimistic updates
     * - Inverting the value of hasVirtualDevice for plots
     * - Adding one DWS when hasVirtualDevice is false
     * - Subtracting one DWS  when hasVirtualDevice is currently true
     */
    const handleHasVirtualDeviceChange = () => {
        if (!isNil(plot) && !isNil(org)) {
            queryClient.setQueryData(orgRequester.key, () => ({
                ...org,
                virtualDevicesCount: plot.hasVirtualDevice
                    ? org.virtualDevicesCount - 1
                    : org.virtualDevicesCount + 1
            }));
            queryClient.setQueryData(plotRequester.key, () => ({
                ...plot,
                hasVirtualDevice: !plot.hasVirtualDevice
            }));
            updateDevices({
                hasVirtualDevice: !plot?.hasVirtualDevice,
                deviceIds: getDeviceIds ? getDeviceIds() : plot.deviceIds
            }, {
                onSuccess: () => {
                    orgRequest.refetch();
                    plotRequest.refetch();
                    if (onSuccess)
                        onSuccess();
                }
            });
        }
    };
    /**
     * Returning null for org with unlimited activations
     * Returning 0 if the value is negative OR we don't have the org
     */
    const remainingVirtualDeviceActivations = useMemo(() => {
        let remaining = 0;
        if (!isNil(org)) {
            if (!isNil(org.virtualDevicesQuota)) {
                const final = org?.virtualDevicesQuota - org?.virtualDevicesCount;
                if (final > 0) {
                    remaining = final;
                }
            }
            // Unlimited activations
            else {
                remaining = null;
            }
        }
        return remaining;
    }, [org]);
    return {
        org,
        isDisabled: updateDevicesRequest.isPending || remainingVirtualDeviceActivations === 0,
        handleHasVirtualDeviceChange,
        hasVirtualDevice: !isNil(plot) ? !!plot?.hasVirtualDevice : false,
        remainingVirtualDeviceActivations
    };
};
export default useVirtualDevice;
